"use strict";
/**
 * Round a number (up) to the first n digits
 * @example 12.34 => 12.34
 * @example 12345.67 => 12350
 * @example 1234567.89 => 1235000
 */
Object.defineProperty(exports, "__esModule", { value: true });
var relativeRound = function (value, numberOfDigitsToKeep) {
    if (numberOfDigitsToKeep === void 0) { numberOfDigitsToKeep = 3; }
    // Log will error out on 0 so just return 0 back
    if (!value)
        return 0;
    // Determine the level of rounding that is needed
    var tier = Math.floor(Math.log10(Math.abs(value)));
    // Keep the first n digits of the number
    var roundingLevel = tier - numberOfDigitsToKeep;
    // Divide the number by the rounding level to set up the round
    var adjusted = value / Math.pow(10, roundingLevel);
    // Always round up to be on the safe side and
    var rounded = Math[value < 0 ? 'floor' : 'ceil'](adjusted);
    // multiply by the rounding level to get the number back in the correct order
    // of magnitude
    return parseFloat((rounded * Math.pow(10, roundingLevel)).toPrecision(12));
};
exports.default = relativeRound;
